import {
  useEffect,
} from 'react';

import { useRouter } from 'next/router';
import {
  lockWindow, unlockWindow, isEscapeKey,
} from 'utils/dom';

export default function useClosableModal({
  isActive = true,
  shouldLockWindow = false,
  onUrlChanged,
  onClose,
}) {
  const router = useRouter();
  useEffect(() => {
    const handleWindowKeyDown = (ev) => {
      if (isEscapeKey(ev)) {
        onClose?.();
      }
    };
    if (isActive) {
      if (shouldLockWindow) {
        lockWindow();
      }
      window.addEventListener('keydown', handleWindowKeyDown);
      router.events.on('routeChangeComplete', onUrlChanged);
    } else {
      if (shouldLockWindow) {
        unlockWindow();
      }
      window.removeEventListener('keydown', handleWindowKeyDown);
      router.events.off('routeChangeComplete', onUrlChanged);
    }
    return () => {
      router.events.off('routeChangeComplete', onUrlChanged);
      window.removeEventListener('keydown', handleWindowKeyDown);
      if (shouldLockWindow) {
        unlockWindow();
      }
    };
  }, [isActive, onClose, onUrlChanged, router.events, shouldLockWindow]);
}
